// extracted by mini-css-extract-plugin
export default {"message":"message_message__28eE6","message--success":"message_message--success__Ft+c1","message--error":"message_message--error__jEzRo"};